export default {
  flagged_buckets: [],
  flagged_cases: [],
  recent_cases: [],
  loading: true,
  timeline: {
    loading: true,
    filterDates: { dateFrom: null, dateTo: null }
  },
  recentCasesLoading: true,
  flaggedCasesLoading: true
}
